import { render, staticRenderFns } from "./UiAddress.vue?vue&type=template&id=74df8f9c&"
import script from "./UiAddress.vue?vue&type=script&lang=js&"
export * from "./UiAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports